import { extendTailwindMerge as t } from "tailwind-merge";
const i = t({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-lg",
            "display-sm",
            "title-1",
            "title-2",
            "title-3",
            "title-4",
            "title-5",
            "title-6",
            "body-lg",
            "body-md",
            "body-sm",
            "body-xs",
            "caption-lg",
            "caption-md",
            "caption-sm",
            "caption-xs",
            "overline"
          ]
        }
      ]
    }
  }
});
export {
  i as default
};
